/* eslint-disable react/jsx-no-bind */
import React from 'react';
import Icon from 'wonderbly-components/lib/Icon';
import { withNavItem } from 'react-skeletal-nav';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CaretRight } from '../../SVGs';

import './NavItem.scss';

const NavItem = ({
  badgeText,
  href,
  onClick,
  title,
  children,
  route,
  isInRoute,
  icon,
  iconColor
}) => {
  const LinkTag = href ? 'a' : 'button';

  const isRoot = route === 'root';

  // After route, we're only allowed links
  if (!href && !isRoot) {
    return null;
  }

  const badgeColor = iconColor || 'blue-medium';

  return (
    <li
      className={cx('nav-item', {
        'nav-item--root': isRoot,
        'nav-item--child': !isRoot
      })}>
      <LinkTag className="nav-item__link" href={href} onClick={onClick}>
        {icon && (
          <div
            className={cx('nav-item__link__icon', {
              [`color-${iconColor}`]: iconColor
            })}>
            <Icon icon={icon} />
          </div>
        )}
        {title}

        <div className="nav-item__right">
          {badgeText && (
            <div
              className={cx('nav-item__badge text-micro', {
                [`color-bg-${badgeColor}`]: badgeColor
              })}>
              {badgeText}
            </div>
          )}
          {!href && (
            <React.Fragment>
              <div className="nav-item__arrow-vertical">
                <Icon icon={isInRoute ? 'directup' : 'dropdown'} />
              </div>
              <div className="nav-item__arrow-right">
                <CaretRight />
              </div>
              {isInRoute && <div className="nav-item__expand-arrow" />}
            </React.Fragment>
          )}
        </div>
      </LinkTag>
      {children}
    </li>
  );
};

NavItem.propTypes = {
  badgeText: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  isInRoute: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  route: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default withNavItem(NavItem);



// WEBPACK FOOTER //
// ./src/client/js/view/components/HeaderII/Nav/NavItem.js